export function setupScrollTo() {
  $(".toname").on("click", function(e) {
    var el = $(this)
    var name = el.data("toname")
    if (name) {
      var a = $("a[name='" + name + "']")
      scrollToEl(a)
      return false
    }
    return true
  })
  // odczytaj hash
  var hash = window.location.hash
  if (hash) {
    hash = hash.replace("#", "")
    var a = $("a[name='" + hash + "']")
    if (a) {
      scrollToEl(a)
    }
  }
}

function scrollToEl(element, defaultOffset) {
  const breakpoint = 996
  const menu = $(".top__menu")
  const menuToogle = $(".main-menu-trigger")
  const openClass = "opened"
  const hideMenu = () => {
    menuToogle.removeClass(openClass)
    menu.hide()
  }
  if (window.innerWidth <= breakpoint) {
    hideMenu()
  }

  // element = element.replace("link", "");
  var offset = defaultOffset ? defaultOffset : -160
  $("html,body")
    .unbind()
    .animate({ scrollTop: $(element).offset().top + offset }, "slow")
}
